export default __webpack_public_path__ + "static/media/ephemeral_3.2816617f.png";